import { Button, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { updateGroup } from '../AdminMenusRequests'
import toast from 'react-hot-toast'

export const UpdateGroup = ({close,setListOfGroups,selectedGroup,updateScoreBoard}) => {
    const [groupName,setGroupName] = useState('')

    useEffect(()=>{
        setGroupName(selectedGroup.group_name)
    },[])
    const handleSubmit = async (e) => {
        e.preventDefault();
        const toastId = toast.loading('Update group info'); 
        const res  = await updateGroup({id:selectedGroup.id,group_name:groupName});
        if(res.data.status === 200){
            setListOfGroups(res.data.data)
            updateScoreBoard();
            close();
            toast.success(res.data.message,{
                id:toastId
            });
        }else{
            toast.error(res.data.message,{
                id:toastId
            });
        }
    }
    return (
        <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField label = 'Game Name' value={groupName} onChange = {(val)=>setGroupName(val.target.value)} fullWidth required/>
            </Grid>
            <Grid item xs={12} sx={{display:'flex',gap:1,justifyContent:'flex-end'}}>
                <Button variant='outlined' color='error' onClick={close}>
                    Cancel
                </Button>
                <Button variant='contained' color='success' type='submit'>
                    Save
                </Button>
            </Grid>
        </Grid>
        </form>
    )
}